module.exports = __webpack_public_path__ + "static/media/8.23da94ea.png";